// extracted by mini-css-extract-plugin
module.exports = {"title":"SectionTitle_title__1JCtq"};